var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loader"},[_c('transition',{attrs:{"name":"fade"}},[(_vm.loading)?_c('div',{class:{blackout: 1, 'is-loading': _vm.loading}},[_c('div',[_vm._v("Loading...")])]):_vm._e()])],1)}
var staticRenderFns = []

export { render, staticRenderFns }